import { QuestDefinition } from './types';

/**
 * Quest definition for the Manual Room Draw tool (ManualRoomDrawTool / 'manual_room_draw')
 *
 * Maps internal phases to user-facing hint bar translation source strings.
 * These strings must be registered in apps/client/src/hooks/useToolTooltipState.ts
 * for the translation system to pick them up.
 */
export const manualRoomDrawQuest: QuestDefinition = {
  toolName: 'manual_room_draw',
  states: {
    drawing: 'click the room corners to draw the room',
  },
  defaultKey: 'click the room corners to draw the room',
};
